import { DragDropModule } from '@angular/cdk/drag-drop';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MmI18nModule } from 'mm-web-core/i18n';
import { MmLayoutModule } from 'mm-web-core/layout';
import { en_US, NZ_I18N, zh_CN } from 'ng-zorro-antd/i18n';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxEchartsModule } from 'ngx-echarts';
import { SharedModule } from 'shared/shared.module';

import { SignalrService, ThemeService } from '../shared/services';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { LoginLayoutComponent } from './pages/login-layout/login-layout.component';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { ProjectListComponent } from './pages/project-list/project-list.component';
import { EntranceCardComponent } from './pages/project-list/components/entrance-card/entrance-card.component';
import { CommonService } from './service/common';
import { ValidateService } from './service/validate.service';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { MmCommonModule } from '../mm-web-core/common';
import { SubjectService } from './service/subject.service';

registerLocaleData(zh);
registerLocaleData(en);

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

const MM_FRAMEWORK_MODULES = [
    MmCommonModule,
    MmLayoutModule,
    MmI18nModule.forRoot({
        defaultLang: 'zh',
        supportedLangs: ['en', 'zh']
    }),
];

const IMPORTS = [
    BrowserModule,
    AppRoutingModule,
    // PrototypesModule,
    SharedModule.forRoot(),
    ...MM_FRAMEWORK_MODULES,
    IconsProviderModule,
    FormsModule,
    MonacoEditorModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HttpClientJsonpModule,
    NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
    }),
    DragDropModule,
];
const DECLARATIONS = [
    AppComponent,
    ProjectListComponent,
    EntranceCardComponent,
    MainLayoutComponent,
    LoginLayoutComponent,
];
const PROVIDERS = [
    CommonService,
    ValidateService,
    SignalrService,
    ThemeService,
    SubjectService,
    NzMessageService,
    {
        provide: NZ_I18N, useFactory: (translate: TranslateService) => {
            const lang = translate.currentLang || translate.defaultLang;
            switch (lang) {
                case 'en':
                    return en_US;
                case 'zh':
                    return zh_CN;
                default:
                    return en_US;
            }
        },
        deps: [TranslateService]
    }
];

@NgModule({
    declarations: DECLARATIONS,
    imports: IMPORTS,
    providers: PROVIDERS,
    bootstrap: [AppComponent]
})
export class AppModule {

}
